import { CALL_API, REQUEST_GET, REQUEST_POST } from '../middleware/api'
import { SEARCH, SEARCH_COLLECTION } from '../schemas/index'

export const SEARCH_CREATE_REQUEST = 'SEARCH_CREATE_REQUEST'
export const SEARCH_CREATE_SUCCESS = 'SEARCH_CREATE_SUCCESS'
export const SEARCH_CREATE_FAILURE = 'SEARCH_CREATE_FAILURE'
export const FETCH_RECENT_SEARCHES_REQUEST = 'FETCH_RECENT_SEARCHES_REQUEST'
export const FETCH_RECENT_SEARCHES_SUCCESS = 'FETCH_RECENT_SEARCHES_SUCCESS'
export const FETCH_RECENT_SEARCHES_FAILURE = 'FETCH_RECENT_SEARCHES_FAILURE'

export function createSearch(company, attrs) {
  return {
    [CALL_API]: {
      types: [
        SEARCH_CREATE_REQUEST,
        SEARCH_CREATE_SUCCESS,
        SEARCH_CREATE_FAILURE
      ],
      endpoint: `companies/${company.id}/searches.json`,
      requestType: REQUEST_POST,
      schema: SEARCH,
      data: {
        search: attrs
      }
    }
  }
}

export function fetchRecentSearches(company) {
  return {
    [CALL_API]: {
      types: [
        FETCH_RECENT_SEARCHES_REQUEST,
        FETCH_RECENT_SEARCHES_SUCCESS,
        FETCH_RECENT_SEARCHES_FAILURE
      ],
      endpoint: `companies/${company.id}/searches/recent.json`,
      requestType: REQUEST_GET,
      schema: SEARCH_COLLECTION
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/searchActions.js